var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "landing-page-header" }, [
    _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "header-logo" }, [
        _c("img", {
          attrs: {
            src: require("@/common/assets/icons/akkodis-brand-logo.svg"),
            alt: "Akkodis"
          }
        })
      ]),
      _c(
        "div",
        { staticClass: "language-container" },
        [
          _c("ApplicationLanguageControl", {
            attrs: { "container-classes": ["dark-mode"] }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }